// extracted by mini-css-extract-plugin
export default {"cls1":"CoreXNav-cls1__c4262db724787193263f","cls2":"CoreXNav-cls2__c6998ef559b4394c5131 CoreXNav-cls1__c4262db724787193263f"};